export class ChannelDateAssignToEventDateRequestModel {

    constructor(eventDateId: number) {
        this.eventDateId = eventDateId;
    }

    eventDateId?: number;
}
